export default {
	path: "khl_ai_order",
	component: () =>
		import(/* webpackChunkName: "khl-ai-order" */ "@/pages/khlAiOrder/List"),
	meta: { title: "AIGC订单审核" },
	children: [
		{
			path: "join",
			component: () =>
				import(
					/* webpackChunkName: "khl-ai-order-join" */ "@/pages/khlAiOrder/JoinList"
				),
			meta: { title: "报名记录" },
		},
	],
};
